import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import NotifyPage from './pages/NotifyPage';
import './index.css';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/notify" element={<NotifyPage />} />
        {/* Future micro-frontend routes */}
        {/* <Route path="/tanpura" element={<TanpuraApp />} /> */}
        {/* <Route path="/lehra" element={<LehraApp />} /> */}
        {/* <Route path="/notation" element={<NotationApp />} /> */}
      </Routes>
    </Router>
  );
};

export default App;
